import { post } from '@namespace/helpers';

export const getAllTypesBonusesCount = async () =>
  post('/service/bff/v1/bonuses/count/get').then(({ data }) => {
    const { total_count: totalCount } = data;

    return totalCount;
  });
